export { SimpleHeroBanner } from './SimpleHeroBanner';
